import {
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader,
  MotifButton,
  MotifIcon,
} from '@ey-xd/motif-react';
import { useRecoilState } from 'recoil';
import { BUTTON_TITLE, FAILEDTRANSACTION } from '../../../constants/commonConstants';
import { BodyContent, HeaderWrapper, ParagraphStyle } from './styles/modalStyles';
import { Pl_Failure_Modal_State } from '../../../recoil/recoil';

const FailureTransactionModal = () => {
  const [showFailureSubmitModal, setShowFailureSubmitModal] =
    useRecoilState(Pl_Failure_Modal_State);

  const closeButtonProps = {
    title: 'Close Button',
    'aria-label': 'Button to close modal window',
  };

  const closeWarningModal = () => {
    setShowFailureSubmitModal(false);
  };

  const closeWarningModalByCancel = () => {
    setShowFailureSubmitModal(false);
  };

  const Header = ({ children }) => <HeaderWrapper>{children}</HeaderWrapper>;
  const bodyContent = (
    <BodyContent>
      <p>
        {FAILEDTRANSACTION.MESSAGE_LINE1}
        <br></br>
        {FAILEDTRANSACTION.MESSAGE_LINE2}
      </p>
    </BodyContent>
  );
  const headerTitle = (
    <span style={{ marginLeft: 11, fontSize: 16 }}>{FAILEDTRANSACTION.HEADER_TITLE}</span>
  );

  return (
    <>
      <MotifModal
        variant="alt"
        show={showFailureSubmitModal}
        onClose={closeWarningModalByCancel}
        style={{ width: '485px' }}
      >
        <MotifModalHeader closeButtonProps={closeButtonProps}>
          <Header>
            <MotifIcon
              src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTIgMkM2LjQ4IDIgMiA2LjQ4IDIgMTJzNC40OCAxMCAxMCAxMCAxMC00LjQ4IDEwLTEwUzE3LjUyIDIgMTIgMnptMSAxNWgtMnYtMmgydjJ6bTAtNGgtMlY3aDJ2NnoiLz48L3N2Zz4="
              style={{
                color: '#F95D54',
                lineHeight: 1,
              }}
            />
            {headerTitle}
          </Header>
        </MotifModalHeader>
        <MotifModalBody>
          <ParagraphStyle> {bodyContent}</ParagraphStyle>
        </MotifModalBody>
        <MotifModalFooter>
          <MotifButton variant="secondary" type="button" onClick={closeWarningModalByCancel}>
            {BUTTON_TITLE.CLOSE}
          </MotifButton>
        </MotifModalFooter>
      </MotifModal>
    </>
  );
};
export default FailureTransactionModal;
